import BaseParagraph from "./baseParagraph.js";
import { NavLink } from "react-router-dom";
import useColors from "../customHooks/useColors.js";

const BaseHyprelink = (props) => {
  //////////////////////////////////////////////destructured PROPS
  const {
    bold = false,
    italic = false,
    style = {}, //ide na base paragraph u inner komponenti
    to = null,
    href = null,
    children = undefined,
    markActive = false,
    translate = true,
    onClick = () => {},
    className = "",
  } = props;

  //////////////////////////////////////////////current THEME
  const [currentColors] = useColors();

  //////////////////////////////////////////////styles
  const styles = {
    mainHyperlink: {
      color: currentColors.primary,
    },
    href: { textDecoration: "none" },
    to: {},
    activeTo: {
      borderBottom: `2px solid ${currentColors.primary}`,
      textDecoration: "none",
    },
  };

  //////////////////////////////////////////////inner component
  const InnerComponent = () => {
    return (
      <BaseParagraph
        bold={bold}
        italic={italic}
        style={{ ...styles.mainHyperlink, ...style }}
        translate={translate}
      >
        {children}
      </BaseParagraph>
    );
  };

  //////////////////////////////////////////////TO
  if (to) {
    return (
      <span className={className} onClick={onClick}>
        <NavLink
          to={to}
          style={({ isActive }) => {
            let innerStyle = { ...styles.to };
            if (isActive && markActive) {
              innerStyle = { ...innerStyle, ...styles.activeTo };
            }
            return innerStyle;
          }}
        >
          <InnerComponent />
        </NavLink>
      </span>
    );
  }

  //////////////////////////////////////////////HREF
  if (href) {
    return (
      <span className={className} onClick={onClick}>
        <a href={href} target="_blank" style={styles.href}>
          <InnerComponent />
        </a>
      </span>
    );
  }
};

export default BaseHyprelink;
